<div class="background-container">
  <div class="container-sm">
    <img id="profile-img" src="assets/logo-blue.svg">
    <p>Reset your password</p>
    <mpro-password [formControl]="passwordControl" passwordPlaceholder="Type the new password" confirmPasswordPlaceholder="Confirm the new password"></mpro-password>
    <button class="mpro-btn mpro-btn-primary" type="submit" (click)="resetPassword()" [disabled]="!passwordControl.valid">reset password</button>
  </div>
</div>
